
<template>
  <div>
    <div v-if="debug_show_page_name == true" style="color: green">
      inventoty_tabs
    </div>
    <app-header>esma</app-header>
    <div :class="'container ' + pageContainerSize">
      <title-and-search title="申請承認（詳細）"></title-and-search>
      <button class="btn btn-primary"
      :disabled="localIsEditing"
      style="min-width:100px;width: 100px;float: left;margin-left: 10px;" 
      @click="backToList" >＜　戻る</button>
      <br>
      <br>
      <br>
      <sub-table-temp-batch-import v-if="showTable" 
        :sessionId="sessionId"
        :allowCheckBox="showCheckBox"
        @editing="isEditing"
       />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { bus } from '@/libs/bus'
import acl from '@/rules/acl_rules';
import md5 from 'md5';

import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import subTableTempBatchImport from '@/components/sub_pages/sub-table-temp-batch-import';
import { utils } from '@/libs/utils';
export default {
  mixins: [mixinPageCommon,
    mixinDatasource],
  components: {
    'sub-table-temp-batch-import':subTableTempBatchImport
  },
  data() {
    return {
      page_acl: acl.inventory,
      session_id:false,
      show_table:false,
      show_check_box:false,
      local_is_editing:false
    };
  },
  computed: {
    localIsEditing:{
      get(){
        return this.local_is_editing;
      },
      set(v){
        this.local_is_editing = v;
      }
    },
    showCheckBox:{
      get(){
        return this.show_check_box;
      },
      set(v){
        this.show_check_box = v;
      }
    },
    showTable:{
      get(){
        return this.show_table;
      },
      set(v){
        this.show_table = v;
      }
    },
    sessionId:{
      get(){
        return this.session_id;
      },
      set(v){
        this.session_id = v;
      }
    },
  },
  methods: {
    isEditing(v){
      this.localIsEditing = v;
    },
    backToList(){
      var destination = "/approval_history/all/"
      return this.$router.push(destination);
    }
  },
  mounted() {
    this.sessionId = this.$route.params.session_id;
    if(md5("SHOW" + this.sessionId ) == this.$route.params.validate){
      this.showCheckBox = true;
    }else{
      this.showCheckBox = false;
    }
    this.showTable = true;
  },
  beforeDestroy() {},
  beforeMount() {},
};
</script>
<style>
/* 
  To change the .nav-tabs colors, do it at the App.vue page, then it will be global.
*/
</style>



// WEBPACK FOOTER //
// page_0050_approval_history_detail.vue?c5ae9cde